<template>
  <div id="func-31">
    <funcionalidade-header :titulo="tituloNavegacao" :voltar="!isWidget"/>
      <div class="main">
        <extrato-autorizacao-listagem
          :chave-externa="'extrato'"
          :funcionalidade="funcionalidade"
          :lista-externa="listaComData"
          :rota-novo="rotaNovo"
          :rota-historico="rotaHistorico"
          :rota-detalhe="rotaDetalhe"
          :permite-nova-solicitacao="funcionalidade.parametros.permiteNovaSolicitacao"
        >
          <template v-slot:default="{card}">
            <div
              @click="onClickRow(card)"
            >
              <ListaExtratoAutorizacaoCard
                :card="card"
                :showWidgetActions="showWidgetActions"
                :preloadWidget="() => carregaPayloadWidget(card)"
              />
            </div>
          </template>
        </extrato-autorizacao-listagem>
      </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import ExtratoAutorizacaoListagem from '@/views/31/components/ExtratoAutorizacaoListagem.vue'
import ListaExtratoAutorizacaoCard from '@/views/31/components/ListaExtratoAutorizacaoCard.vue'
import { EnumCanalAtendimentoOrigem } from '@/constants/EnumCanalAtendimentoOrigem'
import { preloadWidget } from '@/views/31/PreLoadWidget31'
export default {
  components: { ListaExtratoAutorizacaoCard, FuncionalidadeHeader, ExtratoAutorizacaoListagem },
  data () {
    return {
      contratosList: []
    }
  },
  computed: {
    ...mapState('SetupApp', ['apiFuncionalidade', 'funcionalidade', 'embedJson']),
    ...mapGetters('Login', ['user', 'contratos']),
    ...mapGetters('SetupApp', ['canalAtendimentoOrigem', 'isWidget']),
    showWidgetActions () {
      switch (this.canalAtendimentoOrigem) {
        case EnumCanalAtendimentoOrigem.MOSIA_DESK:
          return true
        default:
          return false
      }
    },
    tituloNavegacao () {
      return this.funcionalidade.parametros.dashboard.nome
    },
    listaComData () {
      let data = []
      this.contratosList.map((obj) => {
        const tempLista = obj.extrato.map((el) => {
          let data = el.guia.dataSolicitacao
          let timestamp = new Date(data).getTime()
          return {
            ...el,
            data_registro: timestamp,
            cardExterno: true,
            tipo_ocorrencia_label: el.guia.descricaoTipoServico,
            protocolo: el.guia.numeroProtocolo
          }
        })
        data.push({
          numeroContrato: obj.numeroContrato,
          extrato: tempLista
        })
      })
      return data
    },
    rotaNovo () {
      return `/${this.funcionalidade.idFuncionalidade}/novo`
    },
    rotaHistorico () {
      return `/${this.funcionalidade.idFuncionalidade}/historico`
    },
    rotaDetalhe () {
      return `/${this.funcionalidade.idFuncionalidade}/detalhe`
    },
    periodoBuscaMeses () {
      return this.funcionalidade.parametros.periodoBuscaMeses
    }
  },
  methods: {
    async init () {
      await this.listaExtratos()
    },
    async listaExtratos () {
      const data = new Date()
      data.setMonth(data.getMonth() - this.periodoBuscaMeses)
      const dataInicial = data.toISOString().split('T')[0]
      const dataFinal = new Date().toISOString().split('T')[0]
      let result = await this.apiFuncionalidade.listaExtratos({
        payload: {
          dataInicial: dataInicial,
          dataFinal: dataFinal
        },
        handlerErrorIgnore: true
      })
      this.contratosList = result.data.contratos
    },
    async onClickRow (row) {
      switch (this.canalAtendimentoOrigem) {
        case EnumCanalAtendimentoOrigem.MOSIA_DESK:
          return true
        default:
          return this.$router.push({
            path: `/${this.funcionalidade.idFuncionalidade}/detalhe`,
            query: {
              idAutorizacao: row['guia']['idAutorizacao']
            }
          })
      }
    },
    carregaPayloadWidget (row) {
      return preloadWidget(
        row,
        this.funcionalidade,
        this.embedJson.atendimento.tokenAtendente,
        this.aplicacao
      )
    }
  },
  created () {
    this.init()
  }
}
</script>
<style lang="less" scoped>
#func-31 {
  .sub {
    font-size: 11px;
    color: #555555;
    margin: 0;
    font-weight: 400;
  }
  .main {
    padding: 20px;
  }
  .listagem-extrato-reembolso {
    border-left: 5px solid var(--situacao-cor);
    border-radius: 6px;
  }
  .situacao-card {
    color: var(--situacao-cor)
  }
}
</style>
